import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Card, { CardHeader } from "material-ui/Card";
import Typography from "material-ui/Typography";
import Avatar from "material-ui/Avatar";
import { red, orange, lightGreen, grey, blue } from "material-ui/colors";
import { capitalize } from "./helpers/presentation.js";
import moment from "moment";
import CardButtonRow from "./CardButtonRow";
import EulaStatus from "./EulaStatus";

const styles = theme => ({
  card: {
    display: "flex",
    flexDirection: "column"
  },
  cardTitle: {
    margin: 16,
    marginBottom: 0
  },
  cardHeader: {
    alignItems: "flex-start"
  },
  pending: {
    width: 30,
    height: 30,
    backgroundColor: orange["500"]
  },
  review: {
    width: 30,
    height: 30,
    backgroundColor: blue["500"]
  },
  active: {
    width: 30,
    height: 30,
    backgroundColor: lightGreen["A700"]
  },
  suspended: {
    width: 30,
    height: 30,
    backgroundColor: red["500"]
  },
  closed: {
    width: 30,
    height: 30,
    backgroundColor: grey["500"]
  },
  lightText: {
    color: "rgba(0, 0, 0, 0.54)"
  }
});

const AccountStatusCard = props => {
  const {
    classes,
    account,
    suspendAccount,
    closeAccount,
    activateAccount,
    reviewAccount
  } = props;

  const transitionsMap = {
    active: [
      { action: suspendAccount, label: "Suspend" },
      { action: closeAccount, label: "Close" }
    ],
    pending: [
      { action: closeAccount, label: "Close" },
      { action: activateAccount, label: "Activate" },
      { action: reviewAccount, label: "Review" }
    ],
    review: [
      { action: closeAccount, label: "Close" },
      { action: activateAccount, label: "Activate" }
    ],
    suspended: [
      { action: closeAccount, label: "Close" },
      { action: activateAccount, label: "Activate" },
      { action: reviewAccount, label: "Review" }
    ],
    closed: [
      { action: activateAccount, label: "Activate" },
      { action: reviewAccount, label: "Review" }
    ]
  };

  const renderStatusHistory = () => {
    return (
      <div>
        <Typography className={classes.lightText}>
          {`Account created: ${moment
            .utc(account.timeCreated)
            .format("MMMM Do, YYYY")}`}
        </Typography>
        <EulaStatus accepted={!!account.eulaVersionAccepted} />
      </div>
    );
  };

  const renderStatus = () => {
    return (
      <div>
        <Typography type="subheading">{capitalize(account.state)}</Typography>
      </div>
    );
  };

  const renderActionRow = () => {
    if (account.name !== "conductor" && account.state in transitionsMap) {
      return <CardButtonRow buttons={transitionsMap[account.state]} />;
    }
  };

  return (
    <Card className={classes.card}>
      <Typography type="title" className={classes.cardTitle}>
        Activation status
      </Typography>

      <CardHeader
        className={classes.cardHeader}
        avatar={<Avatar className={classes[account.state]} />}
        title={renderStatus()}
        subheader={renderStatusHistory()}
      />
      {renderActionRow()}
    </Card>
  );
};

AccountStatusCard.propTypes = {
  classes: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  suspendAccount: PropTypes.func.isRequired,
  closeAccount: PropTypes.func.isRequired,
  activateAccount: PropTypes.func.isRequired,
  reviewAccount: PropTypes.func.isRequired
};

export { AccountStatusCard };

export default withStyles(styles, { name: "AccountStatusCard" })(
  AccountStatusCard
);



// WEBPACK FOOTER //
// ./src/AccountStatusCard.js